module.exports = __webpack_public_path__ + "img/avatar6.d0d972f3.png";